var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// node_modules/classnames/index.js
var require_classnames = __commonJS({
  "node_modules/classnames/index.js"(exports, module) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      var nativeCodeString = "[native code]";
      function classNames() {
        var classes = [];
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (!arg)
            continue;
          var argType = typeof arg;
          if (argType === "string" || argType === "number") {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames.apply(null, arg);
              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(" ");
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames;
        });
      } else {
        window.classNames = classNames;
      }
    })();
  }
});

// src/components/ErrorBoundary.tsx
import React2 from "react";

// src/components/ReportDialog/ReportDialog.tsx
var import_classnames = __toESM(require_classnames());
import React, { useMemo, useRef, useState } from "react";

// esbuild-css-modules-plugin-namespace:/tmp/tmp-4693-0JTqg9YceDaQ/highlight-react/src/components/ReportDialog/styles.module.css.js
var digest = "58c2ad2f20f9f2ab72678155824bcc29275cdaf2eea2436f86279bdd0a242ff0";
var css = `._container_18f8u_1 {
	--brand-color: #744ed4;
	--brand-color-dark: #5629c6;
	--color-text-primary: #111111;
	--color-text-primary-inverted: #fff;
	--color-text-link: var(--brand-color);
	--size-large: 24px;
	--size-medium: 16px;
	--size-small: 12px;
	--size-xSmall: 8px;

	--color-white: #fff;
	--color-gray-100: hsla(0, 0%, 93.7%, 0.49019607843137253);
	--color-gray-200: #f2f2f2;
	--color-gray-300: #eaeaea;
	--color-gray-400: #bdbdbd;
	--color-gray-500: #828282;
	--color-gray-600: #7e7e7e;
	--color-gray-700: #8a8f98;
	--color-gray-800: #2d2f36;

	--font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';

	background: hsl(0deg 0% 0% / 75%);
	font-family: var(--font-family);
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	z-index: 999999;
	backdrop-filter: blur(1px);
	display: flex;
	justify-content: center;
	align-items: center;
}

@media only screen and (max-width: 420px) {
	._card_18f8u_41 {
		max-width: 100vw !important;
		height: 100%;
		border-radius: 0;
	}

	._cardContents_18f8u_47 {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	._form_18f8u_53 {
		height: 100%;
	}

	._textareaLabel_18f8u_57 {
		flex: 1;
	}

	._form_18f8u_53 textarea {
		height: 100%;
	}

	._ad_18f8u_65 {
		display: none;
	}
}

._card_18f8u_41 {
	border-radius: var(--size-xSmall);
	padding: 20px;
	width: 420px;
	max-width: calc(100vw - 1rem);
	background: white;
}

._title_18f8u_78 {
	font-size: 20px;
	color: var(--color-text-primary);
}

._subtitle_18f8u_83 {
	font-size: 13px;
	margin-top: var(--size-medium) !important;
	font-weight: 400;
	color: #8c8b92;
}

._form_18f8u_53 {
	padding-top: var(--size-large);
	display: flex;
	flex-direction: column;
	gap: var(--size-small);
	width: 100%;
}

._form_18f8u_53 label {
	display: flex;
	flex-direction: column;
	font-size: 11px !important;
	font-weight: 500;
	color: var(--color-gray-500);
}

._form_18f8u_53 input {
	height: 28px;
}

._form_18f8u_53 textarea {
	font-family: var(--font-family);
	min-height: 80px;
}

._form_18f8u_53 input,
._form_18f8u_53 textarea {
	background-color: var(--color-white);
	border: 1px solid #dcdbdd;
	border-radius: 6px;
	color: var(--color-gray-500);

	font-size: 13px;
	margin: 8px 0;
	outline: none;
	padding: 4px 6px;
	width: calc(100%);
}

._form_18f8u_53 button {
	align-items: center;
	display: flex;
	justify-content: center;
	height: auto;
	color: var(--color-text-primary-inverted);
	background-color: var(--brand-color);
	text-shadow: none;
	box-shadow: none;
	padding: 4px 6px;
	font-size: 14px;
	border-radius: 6px;
	border: 0;
	cursor: pointer;
}

._form_18f8u_53 button:hover {
	background-color: var(--brand-color-dark);
}

._form_18f8u_53 button[disabled] {
	opacity: 0.5;
	pointer-events: none;
}

._form_18f8u_53 ._closeButton_18f8u_154 {
	background-color: transparent;
	color: #6f6e77 !important;
	font-size: 13px;
	font-family: var(--font-family);
	border: 1px solid var(--color-white);
}

._form_18f8u_53 ._closeButton_18f8u_154:hover {
	background-color: var(--color-gray-100);
	border-color: var(--color-gray-300);
}

._confirmationButton_18f8u_167 {
	float: right;
	margin-top: 3rem;
}

._formFooter_18f8u_172 {
	display: flex;
	flex-direction: row-reverse;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
}

._formActionsContainer_18f8u_180 {
	display: flex;
	flex-direction: row-reverse;
	gap: 6px;
}

._ad_18f8u_65:hover {
	background-color: var(--color-gray-100);
}

._logoContainer_18f8u_190 {
	display: flex;
	align-items: center;
	gap: 6px;

	border: 1px solid var(--color-gray-300);
	border-radius: 6px;
	color: var(--color-gray-500);
	font-size: 13px;
	padding: 4px 8px;
}

._logo_18f8u_190 {
	height: 16px;
}

._buggyButton_18f8u_206 {
	align-items: center;
	background: #5629c6;
	border-radius: 8px;
	border: 1px solid #bdbdbd;
	box-shadow: none;
	color: #fff;
	cursor: pointer;
	display: flex;
	font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI',
		Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji',
		'Segoe UI Emoji', 'Segoe UI Symbol';
	font-size: 14px;
	height: auto;
	justify-content: center;
	min-height: 40px;
	padding: 4px 16px;
	text-shadow: none;
}
`;
(function() {
  if (typeof document === "undefined") {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement("style");
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
var styles_module_css_default = { "container": "_container_18f8u_1", "card": "_card_18f8u_41", "cardContents": "_cardContents_18f8u_47", "form": "_form_18f8u_53", "textareaLabel": "_textareaLabel_18f8u_57", "ad": "_ad_18f8u_65", "title": "_title_18f8u_78", "subtitle": "_subtitle_18f8u_83", "closeButton": "_closeButton_18f8u_154", "confirmationButton": "_confirmationButton_18f8u_167", "formFooter": "_formFooter_18f8u_172", "formActionsContainer": "_formActionsContainer_18f8u_180", "logoContainer": "_logoContainer_18f8u_190", "logo": "_logo_18f8u_190", "buggyButton": "_buggyButton_18f8u_206" };

// src/components/ReportDialog/ReportDialog.tsx
function ReportDialog({
  labelClose = "Cancel",
  labelComments = "Message",
  labelName = "Name",
  labelEmail = "Email",
  labelSubmit = "Submit",
  subtitle2 = "If you\u2019d like to help, tell us what happened below.",
  subtitle = "Our team has been notified.",
  successMessage = "Your feedback has been sent. Thank you!",
  successSubtitle = "Thank you for sending us feedback. If you have any other concerns/questions, reach out to this application's support email.",
  title = "It looks like we\u2019re having issues.",
  placeholderComments = "I typed in a name then clicked the button",
  user,
  onCloseHandler,
  onSubmitHandler,
  hideHighlightBranding = false,
  error
}) {
  const [name, setName] = useState((user == null ? void 0 : user.name) || "");
  const [email, setEmail] = useState((user == null ? void 0 : user.email) || "");
  const [verbatim, setVerbatim] = useState("");
  const [sendingReport, setSendingReport] = useState(false);
  const [sentReport, setSentReport] = useState(false);
  const reportDialogOpenTime = useRef((/* @__PURE__ */ new Date()).toISOString());
  const isValid = useMemo(() => {
    const isValidEmail = !!email.match(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
    );
    return !!name && isValidEmail && !!verbatim;
  }, [name, email, verbatim]);
  React.useEffect(() => {
    var _a;
    if (((_a = window == null ? void 0 : window.H) == null ? void 0 : _a.consumeError) && error) {
      window.H.consumeError(error);
    }
  }, [error]);
  const handleSubmit = (event) => {
    var _a;
    event.preventDefault();
    setSendingReport(true);
    if ((_a = window == null ? void 0 : window.H) == null ? void 0 : _a.addSessionFeedback) {
      window.H.addSessionFeedback({
        verbatim,
        userName: name,
        userEmail: email,
        timestampOverride: reportDialogOpenTime.current
      });
    } else {
      console.warn(
        "Highlight is not initialized. Make sure highlight.run is installed and running."
      );
    }
    new Promise((r) => window.setTimeout(r, 300)).then(() => {
      setSendingReport(false);
      setSentReport(true);
      if (onSubmitHandler) {
        onSubmitHandler();
      }
    });
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: `
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: normal;
						src: local('Inter Regular'), local('InterRegular'),
							url('https://app.highlight.io/font/Inter-Regular.woff2')
								format('woff2');
					}
					@font-face {
						font-display: swap;
						font-family: 'Inter';
						font-style: normal;
						font-weight: 500;
						src: local('Inter Medium'), local('InterMedium'),
							url('https://app.highlight.io/font/Inter-Medium.woff2')
								format('woff2');
					}

					::placeholder {
						color: var(--color-gray-300);
					}
			`
      }
    }
  ), /* @__PURE__ */ React.createElement("main", { className: styles_module_css_default.container }, /* @__PURE__ */ React.createElement("div", { className: styles_module_css_default.card }, sentReport ? /* @__PURE__ */ React.createElement("div", { className: styles_module_css_default.cardContents }, /* @__PURE__ */ React.createElement("h1", { className: styles_module_css_default.title }, successMessage), /* @__PURE__ */ React.createElement("h4", { className: styles_module_css_default.subtitle }, successSubtitle), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: (0, import_classnames.default)(
        styles_module_css_default.button,
        styles_module_css_default.confirmationButton
      ),
      onClick: onCloseHandler
    },
    "Close"
  ))) : /* @__PURE__ */ React.createElement("div", { className: styles_module_css_default.cardContents }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h1", { className: styles_module_css_default.title }, title), /* @__PURE__ */ React.createElement("h2", { className: styles_module_css_default.subtitle }, subtitle, " ", subtitle2)), /* @__PURE__ */ React.createElement(
    "form",
    {
      className: styles_module_css_default.form,
      onSubmit: handleSubmit
    },
    /* @__PURE__ */ React.createElement("label", null, labelName, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "text",
        value: name,
        name: "name",
        autoFocus: true,
        onChange: (e) => {
          setName(e.target.value);
        },
        placeholder: "Tom Jerry"
      }
    )),
    /* @__PURE__ */ React.createElement("label", null, labelEmail, /* @__PURE__ */ React.createElement(
      "input",
      {
        type: "email",
        value: email,
        name: "email",
        onChange: (e) => {
          setEmail(e.target.value);
        },
        placeholder: "mail@mail.com"
      }
    )),
    /* @__PURE__ */ React.createElement("label", { className: styles_module_css_default.textareaLabel }, labelComments, /* @__PURE__ */ React.createElement(
      "textarea",
      {
        value: verbatim,
        placeholder: placeholderComments,
        name: "verbatim",
        rows: 3,
        onChange: (e) => {
          setVerbatim(e.target.value);
        }
      }
    )),
    /* @__PURE__ */ React.createElement("div", { className: styles_module_css_default.formFooter }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: styles_module_css_default.formActionsContainer
      },
      /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "submit",
          disabled: !isValid || sendingReport
        },
        labelSubmit
      ),
      /* @__PURE__ */ React.createElement(
        "button",
        {
          className: styles_module_css_default.closeButton,
          onClick: onCloseHandler,
          type: "button"
        },
        labelClose
      )
    ), !hideHighlightBranding && /* @__PURE__ */ React.createElement("div", { className: styles_module_css_default.ad }, /* @__PURE__ */ React.createElement(
      "a",
      {
        href: "https://highlight.io",
        target: "_blank"
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: styles_module_css_default.logoContainer
        },
        /* @__PURE__ */ React.createElement(
          "img",
          {
            src: "https://www.highlight.io/images/logo-on-dark.png",
            alt: "Highlight",
            className: styles_module_css_default.logo
          }
        ),
        /* @__PURE__ */ React.createElement("span", null, "Powered by highlight.io")
      )
    )))
  )))));
}

// src/components/ErrorBoundary.tsx
var INITIAL_STATE = {
  componentStack: null,
  error: null,
  showingDialog: false
};
var ErrorBoundary = class extends React2.Component {
  constructor() {
    super(...arguments);
    this.state = INITIAL_STATE;
    this.resetErrorBoundary = () => {
      const { onReset } = this.props;
      const { error, componentStack } = this.state;
      if (onReset) {
        onReset(error, componentStack);
      }
      this.setState(INITIAL_STATE);
    };
    this.hideDialog = () => {
      this.setState(__spreadProps(__spreadValues({}, this.state), { showingDialog: false }));
      (this.props.onAfterReportDialogCancelHandler || (() => {
        window.location.href = window.location.origin;
      }))();
    };
    this.onReportDialogSubmitHandler = () => {
      if (this.props.onAfterReportDialogSubmitHandler) {
        this.props.onAfterReportDialogSubmitHandler();
      }
    };
  }
  componentDidCatch(error, errorInfo) {
    const { beforeCapture, onError, showDialog } = this.props;
    if (beforeCapture) {
      beforeCapture(error, errorInfo.componentStack);
    }
    captureReactErrorBoundaryError(error, errorInfo);
    if (onError) {
      onError(error, errorInfo.componentStack);
    }
    if (showDialog !== false) {
      this.setState(__spreadProps(__spreadValues({}, this.state), { showingDialog: true }));
    }
    this.setState({ error, componentStack: errorInfo.componentStack });
  }
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) {
      onMount();
    }
  }
  componentWillUnmount() {
    const { error, componentStack } = this.state;
    const { onUnmount } = this.props;
    if (onUnmount) {
      onUnmount(error, componentStack);
    }
  }
  render() {
    const { fallback, children, customDialog } = this.props;
    const { error, componentStack, showingDialog } = this.state;
    if (error) {
      let element = void 0;
      if (typeof fallback === "function") {
        element = fallback({
          error,
          componentStack,
          resetError: this.resetErrorBoundary
        });
      } else {
        element = fallback;
      }
      if (React2.isValidElement(element)) {
        return /* @__PURE__ */ React2.createElement(React2.Fragment, null, showingDialog && /* @__PURE__ */ React2.createElement(
          ReportDialog,
          __spreadProps(__spreadValues({}, this.props.dialogOptions), {
            onCloseHandler: this.hideDialog,
            onSubmitHandler: this.onReportDialogSubmitHandler
          })
        ), element);
      }
      if (fallback) {
        console.warn("fallback did not produce a valid ReactElement");
      }
      if (showingDialog && customDialog) {
        return customDialog;
      }
      return showingDialog && /* @__PURE__ */ React2.createElement(
        ReportDialog,
        __spreadProps(__spreadValues({}, this.props.dialogOptions), {
          onCloseHandler: this.hideDialog,
          onSubmitHandler: this.onReportDialogSubmitHandler
        })
      );
    }
    if (typeof children === "function") {
      return children();
    }
    return children;
  }
};
function captureReactErrorBoundaryError(error, errorInfo) {
  const component = getComponentNameFromStack(errorInfo.componentStack);
  if (!window.H) {
    console.warn("You need to install highlight.run.");
  } else {
    window.H.consumeError(
      error,
      void 0,
      component ? { component } : void 0
    );
  }
}
function getComponentNameFromStack(componentStack) {
  const stack = componentStack.split("\n");
  if (stack.length < 1) {
    return void 0;
  }
  const leafComponentLine = stack[1].trim();
  const tokens = leafComponentLine.split(" ");
  if (tokens.length !== 4) {
    return void 0;
  }
  return `<${tokens[1]}>`;
}

// src/components/SampleBuggyButton.tsx
import React3 from "react";
var SampleBuggyButton = ({
  children
}) => {
  const [isError, setError] = React3.useState(false);
  if (isError) {
    throw new Error("something bad happened - this is a sample test error");
  }
  return /* @__PURE__ */ React3.createElement(
    "button",
    {
      type: "button",
      className: "buggyButton",
      onClick: () => setError(true)
    },
    children != null ? children : "Throw an Error"
  );
};
export {
  ErrorBoundary,
  ReportDialog,
  SampleBuggyButton
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
